import React, { useState } from 'react';
import { withPrefix } from "gatsby";
import Logo from "../../Logo"
const Index = () => {
  const [fbIcon, setFbicon] = useState("facebook-black.svg")
  const [instaIcon, setInstaIcon] = useState("instagram-black.svg")
  return (
    <footer className="w-full bg-white mx-auto">
      <span className="text-black mb-6">
        <Logo />
      </span>
      <div className="flex md:hidden items-center mt-6 mb-6 md:mb-0">
        <a
          className="mr-3"
          href="https://www.facebook.com/DeliciousXP/"
          target="_blank"
          rel="noreferrer"
        >
          <div tabIndex={0} role="button" onMouseEnter={() => setFbicon("facebook-blue.svg")} onMouseLeave={() => setFbicon("facebook-black.svg")}>
            <img src={withPrefix(`/images/${fbIcon}`)} alt="Facebook icon" width="10" height="17" />
          </div>
        </a>
        <a
          className="mr-3"
          href="https://www.instagram.com/DeliciousExperiences/"
          target="_blank"
          rel="noreferrer"
        >
          <div tabIndex={0} role="button" onMouseEnter={() => setInstaIcon("instagram-blue.svg")} onMouseLeave={() => setInstaIcon("instagram-black.svg")}>
            <img src={withPrefix(`/images/${instaIcon}`)} alt="Instagram icon" height="16" width="16" />
          </div>
        </a>
      </div>

      <div className="flex flex-wrap  md:flex-nowrap lg:justify-between">
        <div className="footer-column hidden md:block">
          <p className="description">
            Delicious Experiences helps companies <strong>bring remote teams together</strong> to celebrate and deepen their bond,<strong> strengthen connections with clients,</strong> and <strong>improve employee happiness.</strong> Our unique culinary experiences focus on bringing people together through engaging, fun, virtual, hands-on events that help catapult your teams and clients to a different time and place.
          </p>
          <a href="/" className="copyright-link">
            © Delicious Experiences 2026
          </a>
        </div>

        <div className="footer-column">
          <ul>
            <li>
              <a href="/" className="font-freight">
                Home
              </a>
            </li>
            <li>
              <a href="/faq" className="font-freight">
                FAQ
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-column lg:order-3">
          <ul>
            <li>
              <a href="/about" className="font-freight">
                About us
              </a>
            </li>
            <li>
              <a href="/contact" className="font-freight">
                Contact
              </a>
            </li>
            <li>
              <a href="/host-an-experience" className="font-freight">
                Host an experience
              </a>
            </li>
            <li>
              <a href="/blog" className="font-freight">
                Blog
              </a>
            </li>
          </ul>
          <div className="md:hidden mt-4">
            <a href="/" className="copyright-link">
              © Delicious Experiences 2026
            </a>
            <ul className="mobile-terms-link mt-4">
              <li>
                <a href="/terms-of-service">Terms of Service</a>
              </li>
              <li>
                {' '}
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-column hidden md:block">
          <div className="items-center flex">
            <a
              className="mr-3"
              href="https://www.facebook.com/DeliciousXP/"
              target="_blank"
              rel="noreferrer"
            >
              <div tabIndex={0} role="button" onMouseEnter={() => setFbicon("facebook-blue.svg")} onMouseLeave={() => setFbicon("facebook-black.svg")}>
                <img src={withPrefix(`/images/${fbIcon}`)} alt="Facebook icon" width="10" height="17" />
              </div>
            </a>
            <a
              className="mr-3"
              href="https://www.instagram.com/DeliciousExperiences/"
              target="_blank"
              rel="noreferrer"
            >
              <div tabIndex={0} role="button" onMouseEnter={() => setInstaIcon("instagram-blue.svg")} onMouseLeave={() => setInstaIcon("instagram-black.svg")}>
                <img src={withPrefix(`/images/${instaIcon}`)} alt="Instagram icon" height="16" width="16" />
              </div>
            </a>
          </div>
          <ul className="terms-link">
            <li>
              <a href="/terms-of-service">Terms of Service</a>
            </li>
            <li>
              {' '}
              <a href="/privacy-policy">Privacy Policy</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};
export default Index;
